import { HttpError } from "@/dashboard/lib/api/errors";

export interface FetchJsonOptions extends RequestInit {
  tenantId?: string | null;
}

export async function fetchJson<T>(url: string, init?: FetchJsonOptions): Promise<T> {
  const { tenantId, headers, ...restInit } = init || {};

  // Normalize headers to a plain object
  const normalizedHeaders: Record<string, string> = {
    "Content-Type": "application/json",
  };

  // Convert Headers object or array to plain object
  if (headers) {
    if (headers instanceof Headers) {
      headers.forEach((value, key) => {
        normalizedHeaders[key] = value;
      });
    } else if (Array.isArray(headers)) {
      headers.forEach(([key, value]) => {
        normalizedHeaders[key] = value;
      });
    } else {
      Object.assign(normalizedHeaders, headers);
    }
  }

  // Include tenant ID from React state in headers (source of truth)
  if (tenantId) {
    normalizedHeaders["x-tenant-id"] = tenantId;
  }

  const res = await fetch(url, {
    credentials: "include", // always include cookies
    headers: normalizedHeaders,
    ...restInit,
  });

  if (!res.ok) {
    let msg = `Request failed (${res.status})`;
    try {
      const { error } = (await res.json()) as { error?: unknown };
      if (typeof error === "string") {
        msg = error;
      }
    } catch {
      // swallow
    }

    throw new HttpError(res.status, msg);
  }

  // 204 No Content → return undefined
  return (res.status === 204 ? undefined : await res.json()) as T;
}
